import axios from "axios";
import { attachLoadingInterceptors } from "./loadingBar";

attachLoadingInterceptors(axios);